module.exports = __webpack_public_path__ + "static/media/usaid_1.615ebec2.png";